__webpack_public_path__ = window.jsResourceBaseUrl
// browser selector needs to go in the header so it can set the appropriate classes on the
// <html> tag - specifically, the `.js` tag which is used to show/hide content on the login page
import '../../vendors/browser_selector'
import '../../vendors/jquery-1.8.3'
import '../../vendors/polyfills'
// Font stuff has to be loaded *in the header* so we have time to load teh font before page renders
import '../../vendors/styles'
